module.exports = __webpack_public_path__ + "img/585.551d21eb.jpg";